export const LIKE_STATUSES = {
  liked: 'liked',
  notLiked: 'notLiked',
} as const;
